import { CodeItem } from 'app/area/codetable/item/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const getDisabledOptions = (originalCodeItem: CodeItem, excludableFieldsOptions: CodeComplexValue<number>[]) => {
  return (originalCodeItem && originalCodeItem.excludeFields && excludableFieldsOptions)
    ?
    originalCodeItem.excludeFields.filter(excludeField =>
      excludableFieldsOptions.every(option => option.value !== excludeField.value)
    )
    : [];
};
